import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 254,
	height: 251,
	viewBox: "0 0 254 251",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M125.861 251C195.173 251 251.361 194.812 251.361 125.5C251.361 56.1883 195.173 0 125.861 0C56.5491 0 0.36084 56.1883 0.36084 125.5C0.36084 194.812 56.5491 251 125.861 251Z",
			fill: "#FAFCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.097 43.6658H75.9512C74.547 43.6658 73.4087 44.8041 73.4087 46.2083V208.946C73.4087 210.351 74.547 211.489 75.9512 211.489H251.097C252.501 211.489 253.64 210.351 253.64 208.946V46.2083C253.64 44.8041 252.501 43.6658 251.097 43.6658Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.137 61.5957H90.9219V85.5414H236.137V61.5957Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.882 61.5957H90.9219V85.5414H131.882V61.5957Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.042 131.028C194.042 139.703 190.427 147.524 184.614 153.077C179.143 158.319 171.708 161.538 163.532 161.538C155.355 161.538 147.93 158.329 142.449 153.087C136.636 147.534 133.021 139.708 133.021 131.028C133.021 114.181 146.674 100.517 163.532 100.517C180.389 100.517 194.042 114.181 194.042 131.028Z",
			fill: "#FAFCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M184.609 153.077C179.138 158.319 171.703 161.538 163.527 161.538C155.35 161.538 147.926 158.329 142.444 153.087C143.791 144.32 150.473 137.328 159.062 135.503C154.551 133.723 151.348 129.329 151.348 124.173C151.348 117.445 156.799 111.994 163.527 111.994C170.254 111.994 175.705 117.445 175.705 124.173C175.705 129.329 172.502 133.723 167.981 135.503C176.57 137.328 183.252 144.325 184.604 153.077H184.609Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.959 191.591H114.094C112.73 191.591 111.623 192.696 111.623 194.06C111.623 195.423 112.73 196.529 114.094 196.529H212.959C214.324 196.529 215.43 195.423 215.43 194.06C215.43 192.696 214.324 191.591 212.959 191.591Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M167.29 177.754H160.69C159.325 177.754 158.218 178.86 158.218 180.223C158.218 181.587 159.325 182.692 160.69 182.692H167.29C168.655 182.692 169.761 181.587 169.761 180.223C169.761 178.86 168.655 177.754 167.29 177.754Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.602 177.754H135.777C134.413 177.754 133.306 178.86 133.306 180.223C133.306 181.587 134.413 182.692 135.777 182.692H151.602C152.967 182.692 154.074 181.587 154.074 180.223C154.074 178.86 152.967 177.754 151.602 177.754Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.276 177.754H175.451C174.086 177.754 172.98 178.86 172.98 180.223C172.98 181.587 174.086 182.692 175.451 182.692H191.276C192.641 182.692 193.747 181.587 193.747 180.223C193.747 178.86 192.641 177.754 191.276 177.754Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.312 71.0999H103.487C102.122 71.0999 101.016 72.2052 101.016 73.5687C101.016 74.9321 102.122 76.0375 103.487 76.0375H119.312C120.677 76.0375 121.783 74.9321 121.783 73.5687C121.783 72.2052 120.677 71.0999 119.312 71.0999Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M82.7394 120.73H36.5465C33.7184 120.73 31.4258 123.023 31.4258 125.851V160.694C31.4258 163.522 33.7184 165.815 36.5465 165.815H82.7394C85.5675 165.815 87.8601 163.522 87.8601 160.694V125.851C87.8601 123.023 85.5675 120.73 82.7394 120.73Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.0294 118.498H33.694C30.9053 118.498 28.6445 120.759 28.6445 123.548V158.533C28.6445 161.322 30.9053 163.582 33.694 163.582H80.0294C82.8181 163.582 85.0789 161.322 85.0789 158.533V123.548C85.0789 120.759 82.8181 118.498 80.0294 118.498Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			transform: "translate(45.3608 128)",
			fill: "white",
			fillOpacity: .01
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.7664 130.119C56.5026 129.46 60.0852 131.597 61.3687 135.026C62.2417 134.842 63.1552 134.862 64.0429 135.1C67.1104 135.921 68.9307 139.074 68.1088 142.142C67.7922 143.323 67.1186 144.353 66.1894 145.11C65.6542 145.546 64.8668 145.465 64.4308 144.93C63.9948 144.395 64.0752 143.607 64.6105 143.171C65.1356 142.743 65.5145 142.164 65.694 141.495C66.1585 139.761 65.1296 137.979 63.3959 137.514C62.673 137.321 61.9252 137.381 61.2546 137.675C61.1982 137.7 61.1409 137.72 61.0832 137.736C60.9748 137.791 60.8565 137.831 60.7304 137.854C60.0506 137.973 59.4023 137.52 59.2824 136.84C58.7789 133.984 56.0559 132.078 53.2005 132.581C50.345 133.085 48.4384 135.808 48.9419 138.663C49.0951 139.532 49.456 140.33 49.9902 141.005C50.2137 141.287 50.466 141.546 50.7426 141.778C51.2723 142.22 51.3428 143.009 50.9001 143.538C50.4574 144.068 49.6691 144.138 49.1394 143.696C48.7316 143.355 48.3595 142.973 48.0296 142.556C47.2398 141.558 46.7055 140.377 46.4799 139.097C45.7366 134.882 48.5512 130.862 52.7664 130.119ZM60.6173 145.135L58.8621 143.38V149.001C58.8621 149.692 58.3025 150.251 57.6121 150.251C56.9218 150.251 56.3621 149.692 56.3621 149.001V143.38L54.6069 145.135C54.1188 145.623 53.3273 145.623 52.8392 145.135C52.351 144.647 52.351 143.856 52.8392 143.367L56.7283 139.478C57.2164 138.99 58.0079 138.99 58.496 139.478C58.4963 139.479 58.4966 139.479 58.4969 139.479L62.3851 143.367C62.8733 143.856 62.8733 144.647 62.3851 145.135C61.897 145.623 61.1055 145.623 60.6173 145.135Z",
			fill: "white"
		})
	]
});
export default SvgEmptyStateUpload;
